// extracted by mini-css-extract-plugin
module.exports = {"button":"button_button__SRc2Y","disabled":"button_disabled__GMmnI"};